import loader from './modules/loader'
import drawerMenu from './modules/drawerMenu'
import scrollAnimationHeader from './modules/scrollAnimationHeader'
import scrollAnimationContents from './modules/scrollAnimationContents'
import link from './modules/link'
import postNavArea from './modules/postNavArea'
import upButton from './modules/upButton'

window.addEventListener('DOMContentLoaded',function(){
	loader()
	upButton()
	drawerMenu()
	scrollAnimationHeader()
	scrollAnimationContents()
	link()
	postNavArea()
})